import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { useState } from "react";
import useColors from "../api/hooks/useColors";
import { operationStatus } from "../components/ActionStatus";

export const StyledSwitch = styled(Switch)(({ theme }) => {
  const colors = useColors();
  return {
    width: 21,
    height: 12,
    padding: 0,
    display: "flex",
    "& .MuiSwitch-switchBase": {
      padding: 1,
      "&.Mui-checked": {
        transform: "translateX(9px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: colors.primary_main,
        },
      },
      "&:not(.Mui-checked)": {
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: colors.primary_32percent,
        },
      },
      "&.Mui-disabled": {
        "&.Mui-checked": {
          color: "#fff",
          "& + .MuiSwitch-track": {
            backgroundColor: colors.primary_16percent,
          },
        },
        "&:not(.Mui-checked)": {
          color: "#fff",
          "& + .MuiSwitch-track": {
            backgroundColor: colors.primary_16percent,
          },
        },
      },
    },
    "& .MuiSwitch-thumb": {
      width: 10,
      height: 10,
      boxShadow: "none",
      borderRadius: 5,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
  };
});

const ToggleSwitch = ({
  defaultValue,
  updateFunction,
  setFetchStatus,
  isPermanentlyDisabled = false,
}) => {
  /*
  This toggle is used with the ActionStatus component that shows the status of the update function.
  It will move immediately on click, while the ActionStatus shows the loading status, and move back in case of an error.
  */
  const [currentValue, setCurrentValue] = useState(defaultValue);
  const [isTempDisabled, setIsTempDisabled] = useState(false);

  const handleChange = (newValue) => {
    setCurrentValue(newValue);
    setIsTempDisabled(true);
    setFetchStatus(operationStatus.LOADING);

    updateFunction(newValue)
      .then(() => {
        setFetchStatus(operationStatus.SUCCESS);
      })
      .catch(() => {
        setFetchStatus(operationStatus.ERROR);
        setCurrentValue(!newValue);
      })
      .finally(() => {
        setIsTempDisabled(false);
      });
  };

  return (
    <StyledSwitch
      checked={currentValue}
      onChange={() => handleChange(!currentValue)}
      disabled={isPermanentlyDisabled || isTempDisabled}
    />
  );
};

export default ToggleSwitch;
